"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableListItem;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
/* eslint jsx-a11y/no-static-element-interactions: 0 */

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    buttonRoot: {
      '&:nth-of-type(odd):hover': {
        backgroundColor: theme.isDark() ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.08)'
      },
      color: theme.palette.text.primary,
      textTransform: 'none'
    },
    label: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      textTransform: 'none',
      verticalAlign: 'inherit'
    },
    labelMany: {
      [theme.breakpoints.down('md')]: {
        display: 'block !important'
      }
    }
  };
});
function TableListItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    href = _ref.href,
    id = _ref.id,
    many = _ref.many,
    to = _ref.to,
    disableHover = _ref.disableHover;
  var classes = useStyles();
  if (to || href) {
    return /*#__PURE__*/_react.default.createElement(_material.Button, {
      classes: {
        label: (0, _classnames.default)(classes.label, many && classes.labelMany),
        root: (0, _classnames.default)(className, classes.buttonRoot)
      },
      component: href ? 'a' : _reactRouterDom.Link,
      fullWidth: true,
      href: href,
      id: id,
      target: href ? '_blank' : undefined,
      to: to,
      variant: "text"
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: disableHover ? className : (0, _classnames.default)(className, classes.buttonRoot),
    id: id
  }, children);
}